import React from 'react'

import styles from './BusinessObjectiveCard.module.scss';
import { ProgressBar } from 'react-bootstrap';
import CustomProgressBar from '../../../../components/CustomProgressBar/CustomProgressBar';

type BusinessObjectiveCardType = {
    objective?: string;
    quarter?: string;
    category?: string;
    progressCount: number;
    track?: string;
}

export default function BusinessObjectiveCard({
    objective,
    quarter,
    category,
    progressCount,
    track
}: BusinessObjectiveCardType) {
    return (
        <div className={` ${styles.cardProps} row`} style={{ margin: '0.5rem auto'}}>
            <div className='col'>
                <div className={styles.objective}>
                    {objective}
                </div>
                <div className={styles.quarter}>
                    {quarter} • {category}
                </div>
            </div>
            <div className='col-md-4'>
                <div className={styles.progressWrapper}>
                   <CustomProgressBar progressCount={progressCount}></CustomProgressBar>
                    <span className={styles.progressNumber}>{progressCount}%</span>
                </div>
                <div className={styles.track}>
                    {track}
                </div>
            </div>
        </div>
    )
}
